/* global SERVER_URL */
// require('es6-promise').polyfill();
import fetch from 'isomorphic-fetch';
// import queryString from 'query-string';
import get from 'lodash/get';
import BrowserStore from 'store2';
import ExploreAuth from '../utils/ExploreAuth';
import { checkHttpStatus, parseJSON } from '../utils';
import { setCurrentItemByUsername } from './currentItem';
import {
  updateMemberProfileFavorites,
  // memberProfileRequest,
} from './memberProfile';
import { authLogoutAndRedirect } from './auth';
import {
  ADD_USER_FAVORITE_REQUEST,
  ADD_USER_FAVORITE_SUCCESS,
  ADD_USER_FAVORITE_FAILURE,
  REMOVE_USER_FAVORITE_REQUEST,
  REMOVE_USER_FAVORITE_SUCCESS,
  REMOVE_USER_FAVORITE_FAILURE,
  FETCH_USER_FAVORITE_REQUEST,
  FETCH_USER_FAVORITE_SUCCESS,
  FETCH_USER_FAVORITE_FAILURE,
  RESET_USER_FAVORITES,
  TOGGLE_SNAPSHOT_FAVORITE,
  TOGGLE_SNAPSHOT_FAVORITE_SUCCESS,
  TOGGLE_SNAPSHOT_FAVORITE_FAILURE,
  DELETE_USER_SNAPSHOT_REQUEST, DELETE_USER_SNAPSHOT_SUCCESS, DELETE_USER_SNAPSHOT_FAILURE,
} from '../constants';

export function fetchUserFavoritesRequest() {
  return {
    type: FETCH_USER_FAVORITE_REQUEST,
  };
}

export function fetchUserFavoritesFailure(error) {
  return {
    type: FETCH_USER_FAVORITE_FAILURE,
    statusType: error.type,
    statusMessage: error.message,
  };
}

export function fetchUserFavoritesSuccess(data) {
  BrowserStore.session.set('favorites', data);
  return {
    type: FETCH_USER_FAVORITE_SUCCESS,
    payload: data,
  };
}

export function removeUserFavoriteRequest() {
  return {
    type: REMOVE_USER_FAVORITE_REQUEST,
  };
}

export function removeUserFavoriteFailure(error) {
  return {
    type: REMOVE_USER_FAVORITE_FAILURE,
    statusType: error.type,
    statusMessage: error.message,
  };
}

export function removeUserFavoriteSuccess(data) {
  return {
    type: REMOVE_USER_FAVORITE_SUCCESS,
    payload: data.feed_id,
  };
}

export function resetUserFavorites() {
  return {
    type: RESET_USER_FAVORITES,
  };
}

export function addUserFavoriteRequest() {
  return {
    type: ADD_USER_FAVORITE_REQUEST,
  };
}

export function addUserFavoriteFailure(error) {
  return {
    type: ADD_USER_FAVORITE_FAILURE,
    statusType: error.type,
    statusMessage: error.message,
  };
}

export function addUserFavoriteSuccess(data) {
  return {
    type: ADD_USER_FAVORITE_SUCCESS,
    payload: data.feed_id,
  };
}

export function toggleSnapshotFavoriteRequest() {
  return {
    type: TOGGLE_SNAPSHOT_FAVORITE,
  };
}

export function toggleSnapshotFavoriteSuccess(data) {
  return {
    type: TOGGLE_SNAPSHOT_FAVORITE_SUCCESS,
    payload: data,
  };
}

export function toggleSnapshotFavoriteFailure() {
  return {
    type: TOGGLE_SNAPSHOT_FAVORITE_FAILURE,
  };
}

export function deleteUserSnapshotRequest() {
  return {
    type: DELETE_USER_SNAPSHOT_REQUEST,
  };
}

export function deleteUserSnapshotSuccess(data) {
  return {
    type: DELETE_USER_SNAPSHOT_SUCCESS,
    payload: data,
  };
}

export function deleteUserSnapshotFailure() {
  return {
    type: DELETE_USER_SNAPSHOT_FAILURE,
  };
}

// AddUserFavorite
// addUserFavorite takes: favId, type
export function addUserFavorite(favId, type) {
  return (dispatch) => {
    dispatch(addUserFavoriteRequest());
    return ExploreAuth.getValidJwt()
      .then((tokenIsValid) => {
        // Token can't be refreshed log them out
        if (!tokenIsValid) {
          // We should probably add a modal here informing them they need to log back in.
          return authLogoutAndRedirect();
        }

        return fetch(`${SERVER_URL}/add_favorite`, {
          method: 'post',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${ExploreAuth.getJwt()}`,
          },
          body: JSON.stringify({ id: favId, type }),
        })
          .then(checkHttpStatus)
          .then(parseJSON)
          .then((response) => {
            dispatch(addUserFavoriteSuccess(response.data));
          })
          .catch((error) => {
            dispatch(addUserFavoriteFailure(error));
          });
      });
  };
}

// FetchUserFavorites
// fetchUserFavorites takes a userId, fetches '/get_user_info'
export function fetchUserFavorites(userId) {
  return (dispatch) => {
    dispatch(fetchUserFavoritesRequest());
    return fetch(`${SERVER_URL}/get_user_favorites.json?id=${userId}`, {
      method: 'get',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
    })
      .then(checkHttpStatus)
      .then(parseJSON)
      .then((response) => {
        dispatch(fetchUserFavoritesSuccess(response.data.favorites));
      })
      .catch((error) => {
        dispatch(fetchUserFavoritesFailure(error));
      });
  };
}

// RemoveUserFavorite
// removeUserFavorite takes: favId, type
export function removeUserFavorite(favId, type) {
  return (dispatch, getState) => {
    const state = getState();
    dispatch(removeUserFavoriteRequest());
    ExploreAuth.getValidJwt()
      .then((tokenIsValid) => {
        // Token can't be refreshed log them out
        if (!tokenIsValid) {
          // We should probably add a modal here informing them they need to log back in.
          return dispatch(authLogoutAndRedirect());
        }
        return fetch(`${SERVER_URL}/remove_favorite`, {
          method: 'post',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${ExploreAuth.getJwt()}`,
          },
          body: JSON.stringify({ id: favId, type }),
        })
          .then(checkHttpStatus)
          .then(parseJSON)
          .then((response) => {
            dispatch(removeUserFavoriteSuccess(response.data));
            if (get(state.currentItem.data, 'id') === response.data.feed_id) {
              if (state.currentItem.data.cam_group.id === state.auth.userName) {
                dispatch(
                  setCurrentItemByUsername(
                    { group: state.auth.userName },
                    state.cam_groups.data,
                  ),
                );
              }
            }
          })
          .catch((error) => {
            dispatch(removeUserFavoriteFailure(error));
          });
      });
  };
}

export function updateUserFavoritesOrder(favorites) {
  return (dispatch, getState) => {
    ExploreAuth.getValidJwt()
      .then((tokenIsValid) => {
        // Token can't be refreshed log them out
        if (!tokenIsValid) {
          // We should probably add a modal here informing them they need to log back in.
          return authLogoutAndRedirect();
        }
        return fetch(`${SERVER_URL}/update_favorites_order`, {
          method: 'post',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${ExploreAuth.getJwt()}`,
          },
          body: JSON.stringify({ favorites }),
        })
          .then(checkHttpStatus)
          .then(parseJSON)
          .then((response) => {
            const favoritesResponse = response.data.favorites;
            dispatch(updateMemberProfileFavorites(favoritesResponse));
            const ids = favoritesResponse.map((fav) => {
              return fav.id;
            });
            const state = getState();
            const favs = state.favorites.user;
            favs.livecams = ids;
            dispatch(fetchUserFavoritesSuccess(favs));
          });
      });
  };
}

// AddUserFavorite
// addUserFavorite takes: favId, type
export function toggleUserFavoriteSnapshot(snapshotUuid) {
  return (dispatch, getState) => {
    const state = getState();
    dispatch(toggleSnapshotFavoriteRequest());
    return ExploreAuth.getValidJwt()
      .then((tokenIsValid) => {
        // Token can't be refreshed log them out
        if (!tokenIsValid) {
          // We should probably add a modal here informing them they need to log back in.
          return authLogoutAndRedirect();
        }

        return fetch(`${SERVER_URL}/snapshots/toggle-favorite`, {
          method: 'post',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${ExploreAuth.getJwt()}`,
          },
          body: JSON.stringify({ uuid: snapshotUuid }),
        })
          .then(checkHttpStatus)
          .then(parseJSON)
          .then((response) => {
            dispatch(toggleSnapshotFavoriteSuccess(response.data));
            return dispatch(fetchUserFavorites(state.auth.userId));
          })
          .catch((error) => {
            dispatch(toggleSnapshotFavoriteFailure(error));
          });
      });
  };
}

export function deleteUserSnapshot(snapshotUuid) {
  return (dispatch, getState) => {
    const state = getState();
    dispatch(deleteUserSnapshotRequest());
    return ExploreAuth.getValidJwt()
      .then((tokenIsValid) => {
        // Token can't be refreshed log them out
        if (!tokenIsValid) {
          // We should probably add a modal here informing them they need to log back in.
          return authLogoutAndRedirect();
        }

        return fetch(`${SERVER_URL}/snapshots/delete`, {
          method: 'post',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${ExploreAuth.getJwt()}`,
          },
          body: JSON.stringify({ uuid: snapshotUuid }),
        })
          .then(checkHttpStatus)
          .then(parseJSON)
          .then((response) => {
            return dispatch(deleteUserSnapshotSuccess(response));
          })
          .catch((error) => {
            return dispatch(deleteUserSnapshotFailure(error));
          });
      });
  };
}
